<template>
    <div class="info-container">
        <div class="additional-info-wrapper">

            <div class="additional-info-label" style="margin-left: 32px;">عنوان</div>
            <div class="additional-info-item" style="position: relative">
                <!-- {{ cargo.title.length < 35 ? cargo.title :  cargo.title.substring(0, 35) + "..." }} -->
                {{ cargo.title }}
                <div v-if="owner?.isAccepted == 1" >
                    <div class="ownerLabel">تایید شده</div>
                </div>
            </div>
            <!-- <div class="ownerLabel">تایید شده</div> -->
            <!-- <div class="col-4" v-if="owner?.isAccepted == 1">
                    <span class="ownerLabel">تایید شده</span>
                </div> -->
        </div>
        <div class="additional-info-wrapper">
            <div class="additional-info-label" style="margin-left: 32px;">ناوگان</div>
            <div class="additional-info-item">
                <span v-for="fleet in fleets" :key="fleet.id">
                    {{ fleet.title + ' ' }}
                </span>
            </div>
        </div>

        <div class="additional-info-wrapper">
            <div class="additional-info-label" style="margin-left: 14px;">توضیحات</div>
            <div v-if="cargo.description != null">
                <div v-if="cargo.description.length < 40" class="additional-info-item">{{ cargo.description }}</div>
                <div v-else class="additional-info-item">{{ cargo.description.substring(0, 40) + "..." }}</div>
            </div>
            <div class="additional-info-item" v-else>
                -
            </div>
        </div>
        <!-- <div class="return-loads-text">
            <a style="float: left;color: var(--Primery, #068b80);" href="#">مشاهده جزئیات بار
            </a>
        </div> -->
    </div>
</template>
<script>
export default {
    props: ['cargo', 'owner'],
    data() {
        return {
            fleets: JSON.parse(this.cargo.fleets),
        };
    },
}
</script>
<style scoped>
.info-container {
    font-size: 12px;
    border-bottom: 1px solid #d9d9d9;
    padding-bottom: 8px;
}

.additional-info-wrapper {
    display: flex;
    margin-top: 8px;
    padding-right: 5px;
}

.additional-info-item {
    justify-content: center;
    color: var(--Black, #000);
    font-weight: 500;
    font-size: 12px;
    text-align: right;
    flex: 1;
    padding-right: 16px;
    border-right: 1px solid #d9d9d9;
}

.additional-info-label {
    margin-left: 20px;
}

.ownerLabel {
    width: 67px;
    font-size: 11px;
    position: absolute;
    left: 0;
    top: 6px;
    text-align: center;
    border-radius: 0 9px;
    transform: rotate(311deg);
    background-color: #0ea47a;
    color: white;
}
</style>